const glassWallSettings = {
  thickness: 22,
};

export default glassWallSettings;
